import ChatIcon from '@mui/icons-material/ChatOutlined';
import ManageListingsIcon from '@mui/icons-material/CollectionsBookmarkOutlined';
import BookingIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import ProfileIcon from '@mui/icons-material/PersonOutlined';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { useRouter } from '../../hooks/useRouter';
import { useAppSelector } from '../../redux/hooks';
import { styles } from '../../theme/theme';

const MobileNav: React.FC = () => {
  const currentUser = useAppSelector((state) => state.auth.user);
  const router = useRouter();
  // Server-rendered on SSR pages (PageWithHeader hides it with CSS on
  // desktop), so seed from the router rather than `window` - the server's
  // StaticRouter and the client's BrowserRouter agree on the pathname, so
  // hydration sees the same selected tab.
  const { pathname } = useLocation();
  const [value, setValue] = React.useState(pathname);

  const handleChange = (newValue: string) => {
    router.push(newValue);
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        height: styles.bottomBarHeight,
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        sx={{
          height: '100%',
        }}
      >
        <BottomNavigationAction
          value={'/'}
          label="Home"
          icon={<HomeIcon />}
          onClick={() => handleChange('/')}
        />
        <BottomNavigationAction
          value={'/bookings'}
          label="Bookings"
          icon={<BookingIcon />}
          onClick={() => handleChange('/bookings')}
        />
        {currentUser && currentUser?.roles?.includes('owner') && (
          <BottomNavigationAction
            value={'/manage/vessels'}
            label="Listings"
            icon={<ManageListingsIcon />}
            onClick={() => handleChange('/manage/vessels')}
          />
        )}
        <BottomNavigationAction
          value={'/messages'}
          label="Chat"
          icon={<ChatIcon />}
          onClick={() => handleChange('/messages')}
        />
        <BottomNavigationAction
          value={'/user-profile'}
          label="Profile"
          icon={<ProfileIcon />}
          onClick={() => handleChange('/user-profile')}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default MobileNav;
